import { Component, Input, OnDestroy, OnInit, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddExceptionComponent } from './dialog/add-exception/add-exception.component';
import { dataStore, db } from 'src/app/app.component';
import { doc, getDoc, onSnapshot, setDoc } from 'firebase/firestore';
import { MatCard, MatCardContent } from '@angular/material/card';
import { CdkVirtualScrollViewport, CdkFixedSizeVirtualScroll } from '@angular/cdk/scrolling';
import { MatIconButton, MatFabButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-exceptions',
  templateUrl: './exceptions.component.html',
  styleUrls: ['./exceptions.component.scss'],
  imports: [
    MatCard,
    MatCardContent,
    CdkVirtualScrollViewport,
    CdkFixedSizeVirtualScroll,
    MatIconButton,
    MatIcon,
    MatFabButton,
    DatePipe,
  ],
})
export class ExceptionsComponent implements OnInit, OnDestroy {
  allExceptions = signal<any[]>([]);
  exceptions = signal<any[]>([]);
  organisationId = localStorage.getItem('orgId');
  userId: string | null = null;
  userIdFromAdmin: string | null = null;
  exceptionsUnsub: (() => void) | null = null;

  @Input() set getUserId(userId: string) {
    this.userIdFromAdmin = userId ? userId : null;
    this.getException();
  }
  @Input() userCanModify: boolean = false;

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.exceptionsUnsub?.();
  }

  async deleteException(index: number) {
    const userDocRef = doc(db, `organisations/${this.organisationId}/users/${this.userId}`);
    const userSnap = await getDoc(userDocRef);
    const user = userSnap.data();

    if (user && user.exceptions) {
      const exceptions = [...user.exceptions];
      if (index >= 0 && index < exceptions.length) {
        exceptions.splice(index, 1);
        await setDoc(userDocRef, { exceptions }, { merge: true });
      }
    }
  }

  getException() {
    this.userId = this.userIdFromAdmin ? this.userIdFromAdmin : dataStore.rootUser.id!;
    if (this.exceptionsUnsub) {
      this.exceptionsUnsub();
    }

    this.exceptionsUnsub = onSnapshot(
      doc(db, `organisations/${this.organisationId}/users/${this.userId}`),
      (snapshot) => {
        const user = snapshot.data();
        const allExceptions: any[] = [];
        const exceptions: any[] = [];
        if (user?.exceptions) {
          user.exceptions.forEach((exception: any, index: number) => {
            const newObj = {} as any;
            newObj.dateTo = exception.dateTo.toDate();
            newObj.dateFrom = exception.dateFrom.toDate();
            newObj.index = index;
            newObj.name = exception.name;
            allExceptions.push(newObj);
            if (newObj.dateTo < new Date()) {
              // prevent old dates being pushed
              return;
            }
            exceptions.push(newObj);
          });
        }
        this.allExceptions.set(allExceptions);
        this.exceptions.set(
          exceptions.sort(function (a, b) {
            return <any>new Date(a.dateFrom) - <any>new Date(b.dateFrom);
          }),
        );
      },
    );
  }

  openAddExceptionDialog(exception?: any) {
    this.dialog.open(AddExceptionComponent, {
      width: '475px',
      data: {
        userId: this.userId,
        exception: exception ?? null,
      },
    });
  }

  get getUserId() {
    return this.userIdFromAdmin!;
  }
}
